<template>
  <div>
    <ModalWithTabs
      name="tipoTicketEtapaEdit"
      :tabs="tabsConfig"
      @before-open="onModalOpen"
      @closed="onModalClosed"
    >
      <template #0>
        <div class="xrow">
          <div class="col-1-2">
            <div class="form-group">
              <label>
                <span>Chave</span>
                <ShowHint hint="hintChave"/>
              </label>
              <input class="form-control" v-model="item.chave" />
              <div class="message">{{ validation.firstError('item.chave') }}</div>
            </div>
          </div>
          <div class="col-1-2">
            <div class="form-group">
              <label>Descrição</label>
              <input class="form-control" v-model="item.desc" />
              <div class="message">{{ validation.firstError('item.desc') }}</div>
            </div>
          </div>
        </div>
        <div class="xrow">
          <div class="col-1-1">
            <div class="form-group">
              <label>Observação</label>
              <textarea class="form-control" v-model="item.obs" />
              <div class="message">{{ validation.firstError('item.obs') }}</div>
            </div>
          </div>
        </div>
        <div class="xrow">
          <div class="col-1-3">
            <div class="form-group">
              <label>SLA máximo</label>
              <input class="form-control" v-model="item.sla_maximo" type="number" autocomplete="chrome-off" />
              <div class="message">{{ validation.firstError('item.sla_maximo') }}</div>
            </div>
          </div>
          <div class="col-1-3">
            <div class="form-group">
              <label>Permite finalizar</label>
              <select class="form-control" v-model="item.permite_finalizar">
                <option value="1">Sim</option>
                <option value="0">Não</option>
              </select>
              <div class="message">{{ validation.firstError('item.permite_finalizar') }}</div>
            </div>
          </div>
          <div class="col-1-3">
            <div class="form-group">
              <label>Permite retroceder</label>
              <select class="form-control" v-model="item.permite_retroceder">
                <option value="1">Sim</option>
                <option value="0">Não</option>
              </select>
              <div class="message">{{ validation.firstError('item.permite_retroceder') }}</div>
            </div>
          </div>
        </div>
        <div class="xrow">
          <div class="col-1-3">
            <div class="form-group">
              <label>Aguarda cliente</label>
              <select class="form-control" v-model="item.aguarda_cliente">
                <option value="1">Sim</option>
                <option value="0">Não</option>
              </select>
              <div class="message">{{ validation.firstError('item.aguarda_cliente') }}</div>
            </div>
          </div>
          <div class="col-1-3">
            <div class="form-group">
              <label>Requerimento</label>
              <select class="form-control" v-model="item.requerimento" @change="onRequerimentoChange">
                <option value="">-</option>
                <option v-for="(desc, key) in tipoTicketEtapaRequerimento" :value="key" :key="key">
                  {{ desc }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-1-3">
            <div class="form-group">
              <label>Requerimento ID</label>
              <select class="form-control" v-model="item.requerimento_id" :disabled="item.requerimento !== 'CUSTOM_FORM'">
                <option value="">-</option>
                <option v-for="(desc, key) in tipoTicketEtapaRequerimentoId" :value="key" :key="key">
                  {{ desc }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="xrow">
          <div class="col-1-3">
            <div class="form-group">
              <label>Permite avançar</label>
              <select class="form-control" v-model="item.permite_avancar">
                <option value="1">Sim</option>
                <option value="0">Não</option>
              </select>
              <div class="message">{{ validation.firstError('item.permite_avancar') }}</div>
            </div>
          </div>
          <div class="col-1-3">
            <div class="form-group">
              <label>Final</label>
              <select class="form-control" v-model="item.final">
                <option value="1">Sim</option>
                <option value="0">Não</option>
              </select>
              <div class="message">{{ validation.firstError('item.final') }}</div>
            </div>
          </div>
          <div class="col-1-3">
            <div class="form-group">
              <label>Setor</label>
              <select class="form-control" v-model="item.setor_id">
                <option value="">-</option>
                <option v-for="setor in setores" :value="setor.id" :key="setor.id">
                  {{ setor.desc }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="xrow">
          <div class="col-1-3">
            <div class="form-group">
              <label>Permite custos</label>
              <select class="form-control" v-model="item.permite_custos">
                <option value="1">Sim</option>
                <option value="0">Não</option>
              </select>
              <div class="message">{{ validation.firstError('item.permite_custos') }}</div>
            </div>
          </div>
          <div class="col-1-3">
            <div class="form-group">
              <label>Usa motivo</label>
              <select class="form-control" v-model="item.usa_motivo">
                <option value="1">Sim</option>
                <option value="0">Não</option>
              </select>
            </div>
          </div>
          <div class="col-1-3">
            <div class="form-group">
              <label>Permite alterar itens</label>
              <select class="form-control" v-model="item.permite_alterar_itens">
                <option value="1">Sim</option>
                <option value="0">Não</option>
              </select>
            </div>
          </div>
        </div>
        <div class="xrow edit-buttons">
          <button :class="{ 'button button-success': true, 'button-disabled': validation.hasError() }"
                  v-on:click="handleSubmit">
            Salvar
          </button>
          &nbsp;
          <button class="button" v-on:click="close">Fechar</button>
        </div>
      </template>

      <template #1>
        <VincularCamposAdicionais
          ref="vincularCampos"
          :item-id="vincularItemId"
          :endpoint="`/admin/sac/tipo-ticket-etapa/${item.id}/campos-adicionais`"
          :sistemasDisponiveis="sistemasDisponiveis"
          :exibir-sistemas="false"
          @saved="close"
        />
      </template>
    </ModalWithTabs>
  </div>
</template>

<script>
import SimpleVueValidation from 'simple-vue-validator';
import ShowHint from '@/components/ShowHint.vue';
import VincularCamposAdicionais from '../VincularCamposAdicionais.vue';
import ModalWithTabs from '../../../../components/ModalWithTabs.vue';

const Validator = SimpleVueValidation.Validator.create({
  templates: {
    required: "*obrigatório"
  },
});

export default {
  name: 'tipoTicketEtapaEdit',
  props: ['item', 'update', 'close', 'doRequest', 'descSingular', 'tipoTicket', 'tipoTicketEtapaRequerimento', 'tipoTicketEtapaRequerimentoId', 'setores'],
  components: { ShowHint, VincularCamposAdicionais, ModalWithTabs },
  data() {
    return {
      vincularItemId: null,
      itemSnapshot: null,
    };
  },
  computed: {
    sistemasDisponiveis() {
      const sistemas = [{ chave: 'SAC', label: 'SAC' }];
      if (this.tipoTicket && parseInt(this.tipoTicket.acessab2b))        sistemas.push({ chave: 'B2B',          label: 'B2B' });
      if (this.tipoTicket && parseInt(this.tipoTicket.acessacallcenter)) sistemas.push({ chave: 'CALLCENTER',   label: 'Callcenter' });
      if (this.tipoTicket && parseInt(this.tipoTicket.acessafv))         sistemas.push({ chave: 'FORCA_VENDAS', label: 'Força de Vendas' });
      return sistemas;
    },
    tabsConfig() {
      return [
        {
          title: this.getTitleModal(this.item) + this.descSingular,
          isDirty: () => this.formIsDirty(),
          onSave: () => this.handleSaveForTabChange(),
          onDiscard: () => this.discardFormChanges(),
        },
        {
          title: 'Vincular Campos Adicionais',
          disabled: !this.item.id,
          isDirty: () => this.$refs.vincularCampos?.isDirty() ?? false,
          onSave: () => this.$refs.vincularCampos?.save(),
          onDiscard: () => this.$refs.vincularCampos?.discard(),
        },
      ];
    },
  },
  validators: {
    'item.tipo_ticket_id'     : (value) => Validator.value(value).required(),
    'item.chave'              : (value) => Validator.value(value).required(),
    'item.desc'               : (value) => Validator.value(value).required(),
    'item.permite_finalizar'  : (value) => Validator.value(value).required(),
    'item.permite_retroceder' : (value) => Validator.value(value).required(),
    'item.ordem'              : (value) => Validator.value(value).required(),
    'item.aguarda_cliente'    : (value) => Validator.value(value).required(),
    'item.permite_avancar'    : (value) => Validator.value(value).required(),
    'item.final'              : (value) => Validator.value(value).required(),
    'item.permite_custos'     : (value) => Validator.value(value).required(),
  },
  methods: {
    onRequerimentoChange() {
      if (this.item.requerimento !== 'CUSTOM_FORM') {
        this.item.requerimento_id = '';
      }
    },
    onModalOpen() {
      this.$nextTick(() => {
        this.vincularItemId = this.item.id || null;
        this.itemSnapshot = JSON.parse(JSON.stringify(this.item));
      });
    },
    onModalClosed() {
      this.vincularItemId = null;
      this.itemSnapshot = null;
    },
    formIsDirty() {
      if (!this.itemSnapshot) return false;
      return JSON.stringify(this.item) !== JSON.stringify(this.itemSnapshot);
    },
    discardFormChanges() {
      if (this.itemSnapshot) Object.assign(this.item, this.itemSnapshot);
    },
    async handleSaveForTabChange() {
      const valid = await this.$validate();
      if (!valid) throw new Error('Preencha os campos obrigatórios.');
      await this.doRequest();
      this.itemSnapshot = JSON.parse(JSON.stringify(this.item));
      this.$refs.vincularCampos?.syncSistemas();
      this.$emit('saved');
      return true;
    },
    handleSubmit() {
      this.$validate().then(async (success) => {
        if (success) {
          const isUpdated = await this.update();
          if (isUpdated) {
            this.$emit('saved');
          }
        }
      });
    },
    getTitleModal(item) {
      if (item.id) {
        return 'Editando ';
      }
      return 'Criando ';
    }
  }
};
</script>

<style scoped>
</style>
